'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const EllipsisVertical = createSvgIcon(
  <path
    fillRule="evenodd"
    d="M12,17 C13.3807119,17 14.5,18.1192881 14.5,19.5 C14.5,20.8807119 13.3807119,22 12,22 C10.6192881,22 9.5,20.8807119 9.5,19.5 C9.5,18.1192881 10.6192881,17 12,17 Z M12,9.5 C13.3807119,9.5 14.5,10.6192881 14.5,12 C14.5,13.3807119 13.3807119,14.5 12,14.5 C10.6192881,14.5 9.5,13.3807119 9.5,12 C9.5,10.6192881 10.6192881,9.5 12,9.5 Z M12,2 C13.3807119,2 14.5,3.11928813 14.5,4.5 C14.5,5.88071187 13.3807119,7 12,7 C10.6192881,7 9.5,5.88071187 9.5,4.5 C9.5,3.11928813 10.6192881,2 12,2 Z"
  />,
  'EllipsisVertical'
);

export default EllipsisVertical;
